import Page from 'component/Page';
import { useEffect, useMemo, useState } from 'react';
import sendRequest, {
  sendPost,
  // sendPut,
} from 'util/request';
import string from 'util/string';
import Urls from 'util/urls';
import Paths from 'util/paths';
import Table from 'component/Table';
// import Modal from 'component/Modal';
// import PocUserAdd from './PocUserAdd';
// import PocUserUpdate from './PocUserUpdate';
// import PocUserChangePassword from './PocUserChangePassword';
import { useSelector } from 'react-redux';
import { selectCurrentUser } from 'redux/user/user.selector';
import { useHistory } from 'react-router-dom';
import { ACCOUNT_ROLE_ADMIN } from 'util/permission';
import { useCallback } from 'react';
import { formatDate, nNU, showConfirm, showToast, getParams } from 'util/utils';

export const accountRoleNameMap = {
  0: string.ACCOUNT_ROLE_ADMIN,
  1: string.ACCOUNT_ROLE_PARENT,
  2: string.ACCOUNT_ROLE_CHILD,
};

export const accountStatusNameMap = {
  true: string.ACTIVE,
  false: string.INACTIVE,
};

const PocUserAddChannels = ({ data = { pocId: null } }) => {
  //-------------------------------HOOKS-------------------------------------------------------------
  const params = getParams();
  const currentUser = useSelector(selectCurrentUser);
  const pocId = data.pocId || params?.pocId || params?.id;
  const [selectedUser, setSelectedUser] = useState(pocId);
  const [userData, setUserData] = useState({});
  const [userChannels, setUserChannels] = useState([]);

  const [users, setUsers] = useState([]);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const isAdmin = useMemo(
    () => currentUser.accountRole === ACCOUNT_ROLE_ADMIN,
    [currentUser.accountRole]
  );
  const isMonitorOnly = useMemo(
    () => currentUser.isMonitorOnly === 1,
    [currentUser.isMonitorOnly]
  );
  const [selectedItem, setSelectedItem] = useState([]);
  const history = useHistory();

  //------------------------------FUNCTIONS----------------------------------------------------------
  useEffect(() => {
    if (!selectedUser) {
      return;
    }
    sendRequest({
      url: `${Urls.pocaccount.account}/${selectedUser}`,
    }).then((response) => {
      const { result } = response;
      setUserData(result);
    });
  }, [selectedUser]);

  const doSearch = useCallback(
    async (page, pageSize, getAll = false) => {
      if (userData?.role !== 'premium') {
        return;
      }
      let data = await sendPost({
        url: Urls.pocchannel.channellist,
        body: {
          id: userData.pocId,
          onlyMember: false,
          offset: (page - 1) * pageSize,
          size: pageSize,
          keyword: '',
        },
      });
      const { total, result } = data;
      if (!getAll) {
        setUserChannels(result);
        setTotal(total);
      }
      return result;
    },
    [userData]
  );
  useEffect(() => {
    doSearch(page, pageSize);
  }, [page, pageSize, doSearch]);
  const dataTable = useCallback(
    (data) =>
      data.map((raw, key) => ({
        key: raw.groupId,
        data: isAdmin
          ? [
              raw.groupName,
              // raw.confSipNumber,
              nNU(raw.email) ? raw.email : currentUser.email,
              raw.status === 1 ? '有効' : '無効',
              formatDate(raw.registerDate, 'YYYY/MM/DD'),
            ]
          : [
              raw.groupName,
              raw.status === 1 ? '有効' : '無効',
              formatDate(raw.registerDate, 'YYYY/MM/DD'),
            ],
        raw,
      })),
    []
  );

  const onSelect = (e) => {
    let { raw } = e;
    let arr;
    let idx = -1;
    selectedItem?.forEach((item, index) => {
      if (item.groupId === raw.groupId) {
        idx = index;
        return;
      }
    });
    if (idx > -1) {
      let { [idx]: itm, ...rest } = selectedItem;
      arr = Object.values(rest);
    } else {
      arr = [...selectedItem, raw];
    }
    setSelectedItem(arr);
  };
  const actions = isMonitorOnly
    ? []
    : [
        ({ raw }) => {
          if (raw.status !== 1) {
            return;
          }
          let idx = -1;
          selectedItem?.forEach((item, index) => {
            if (item.groupId === raw.groupId) {
              idx = index;
              return;
            }
          });
          return selectedItem.indexOf(raw.groupId) > -1
            ? null
            : {
                render: idx > -1 ? 'selected' : 'select',
                onClick: onSelect,
              };
        },
      ];
  const onAddMultiple = () => {
    if (selectedItem.length < 1) {
      return;
    }
    const data = {
      pocId: userData.pocId,
      groupIds: [...selectedItem.map((item) => item.groupId)],
      remove: false,
    };
    // console.log(data);
    showConfirm({
      body: string.POC_ACCOUNT_CHANNEL_ADD_CONFIRM,
      defaultAction: () => {
        sendPost({
          url: Urls.pocchannel.channelmulti,
          body: data,
        })
          .then((res) => {
            showToast(string.POC_ACCOUNT_CHANNEL_ADD_SUCCESS, 'success');
            // doSearch(page, pageSize);
            history.push(`${Paths.pocaccount.detail}/?id=${userData.pocId}`);
          })
          .catch((e) => {
            console.log('削除エラー');
          });
      },
    });
  };
  const mainActions =
    total > 0
      ? [
          {
            icon: 'assign',
            title: string.ADD,
            onClick: () => onAddMultiple(),
          },
          {
            icon: 'none',
            title: string.SELECT_ALL,
            onClick: () => setSelectedItem(userChannels),
          },
          {
            icon: 'none',
            title: string.UN_SELECT_ALL,
            onClick: () => setSelectedItem([]),
          },
        ]
      : null;

  //-------------------------------RETURN------------------------------------------------------------
  return (
    <>
      <Page
        title={
          nNU(userData?.username) &&
          `${string.POC_ACCOUNT_MANAGEMENT} > ${userData?.username} ${string.POC_ACCOUNT_CHANNEL_ADD}`
        }
        body={
          <>
            <Table
              className="nowrap"
              mainActions={mainActions}
              page={page}
              pageSize={pageSize}
              total={total}
              onPageChanged={setPage}
              onPageSizeChanged={setPageSize}
              headers={
                isAdmin
                  ? [
                      string.POC_CHANNEL_NAME,
                      // string.POC_CHANNEL_SIP,
                      string.POC_CHANNEL_OWNER,
                      string.POC_CHANNEL_STATUS,
                      string.POC_CHANNEL_REGISTERED_DATE,
                    ]
                  : [
                      string.POC_CHANNEL_NAME,
                      string.POC_CHANNEL_STATUS,
                      string.POC_CHANNEL_REGISTERED_DATE,
                    ]
              }
              data={dataTable(userChannels)}
              // getCSVData={async () => {
              //   return dataTable(await doSearch(1, total, true));
              // }}
              // csvFileName="AppUserList"
              isPaging={true}
              actions={actions}
              selectedCount={selectedItem.length}
            />
          </>
        }
      />
    </>
  );
};

export default PocUserAddChannels;
